import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import './index.css';
import './setupAxios'; // CSRF interceptor — must run before any component imports axios
import App from './App';
import './i18n'; // used for translating the pages
import { NotificationProvider } from './components/notifications/NotificationProvider';

const rootElement = document.getElementById('root');
const app = (
    <NotificationProvider>
        <App />
    </NotificationProvider>
);

if (rootElement && rootElement.hasChildNodes()) {
    hydrateRoot(rootElement, app);
} else if (rootElement) {
    createRoot(rootElement).render(app);
}